/** @jsx jsx */
import { Box, useTheme } from '@chakra-ui/core'
import { css, jsx } from '@emotion/core'
import { filterXSS } from 'xss'

export const richTextStyles = (theme) =>
  css`
    h1 {
      font-size: ${theme.fontSizes['xl']};
      font-weight: ${theme.fontWeights.bold};
      @media (min-width: ${theme.breakpoints[1]}) {
        font-size: ${theme.fontSizes['2xl']};
      }
    }
    h2 {
      font-size: ${theme.fontSizes['lg']};
      font-weight: ${theme.fontWeights.bold};
        margin-bottom: ${theme.space['2']};
      @media (min-width: ${theme.breakpoints[1]}) {
        font-size: ${theme.fontSizes['xl']};
        margin-bottom: ${theme.space['1']};
      }
    }
    h3 {
      font-size: ${theme.fontSizes['md']};
      font-weight: ${theme.fontWeights.bold};
      @media (min-width: ${theme.breakpoints[1]}) {
        font-size: ${theme.fontSizes['lg']};
      }
      :first-of-type {
        margin-top: 0;
      }
    }
    h4 {
      font-size: ${theme.fontSizes['sm']};
      font-weight: ${theme.fontWeights.bold};
      @media (min-width: ${theme.breakpoints[1]}) {
        font-size: ${theme.fontSizes['md']};
      }
    }
    h5 {
      font-size: ${theme.fontSizes['sm']};
      font-weight: ${theme.fontWeights.bold};
      color: ${theme.colors.gray[700]};
      @media (min-width: ${theme.breakpoints[1]}) {
        font-size: ${theme.fontSizes['md']};
      }
    }
    h6 {
      font-size: ${theme.fontSizes['sm']};
      font-weight: ${theme.fontWeights.bold};
      color: ${theme.colors.gray[700]};
      @media (min-width: ${theme.breakpoints[1]}) {
        font-size: ${theme.fontSizes['sm']};
      }
    }
    p {
      font-size: ${theme.fontSizes['sm']};
      font-weight: ${theme.fontWeights.normal};
      margin-bottom: ${theme.space['4']};
      @media (min-width: ${theme.breakpoints[1]}) {
        margin-bottom: ${theme.space['8']};
        font-size: ${theme.fontSizes['md']};
      }
      :last-of-type {
          margin-bottom: 0;
      }
    }
    a {
      text-decoration: underline;
      text-decoration-color: ${theme.colors.orange[400]};
      transition: 100ms background-color;
      &:hover {
        background-color: ${theme.colors.orange[50]};
      }
    }
    ol,
    ul {
      font-size: ${theme.fontSizes['sm']};
      /* margin-top: ${theme.space['2']}; */
      margin-bottom: ${theme.space['4']};
      font-weight: ${theme.fontWeights.normal};
      padding-left: 1.2rem;
      @media (min-width: ${theme.breakpoints[1]}) {
        margin-bottom: ${theme.space['8']};
        font-size: ${theme.fontSizes['md']};
      }
    }
    li {
      @media (min-width: ${theme.breakpoints[1]}) {
        font-size: ${theme.fontSizes['md']};
      }
    }
    pre {
      background-color: ${theme.colors.gray[50]};
      padding: ${theme.space[4]};
      @media (min-width: ${theme.breakpoints[1]}) {
        font-size: ${theme.fontSizes['md']};
      }
    }
  `

const RichText = ({ children }: Props) => {
  const theme = useTheme()
  if (typeof children !== 'string') return <></>

  return (
    <Box
      css={richTextStyles(theme)}
      dangerouslySetInnerHTML={{
        __html: filterXSS(children),
      }}
    ></Box>
  )
}

type Props = {
  children: string
}

export default RichText
